module.exports = __webpack_public_path__ + "static/media/paulsomberg.eb09e291.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/paulsomberg.webp
// module id = 721
// module chunks = 0